import { useMutation } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Field, FormError } from '@/components/form';
import { AuthShell } from '@/features/auth/auth-shell';
import { api, errorMessage } from '@/lib/api';

export const Route = createFileRoute('/forgot-password')({ component: ForgotPage });

function ForgotPage() {
  const [email, setEmail] = useState('');
  const send = useMutation({ mutationFn: () => api.post('/v1/auth/password/forgot', { email }) });

  function submit(e: FormEvent) {
    e.preventDefault();
    send.mutate();
  }

  const back = (
    <Link to="/login" search={{}} className="text-link underline-offset-4 hover:underline">
      Back to sign in
    </Link>
  );

  if (send.isSuccess) {
    return (
      <AuthShell title="Check your email" description={`If ${email} has a Fraud Safe account, we’ve sent it a link to choose a new password. The link expires in an hour.`} footer={back}>
        <p className="text-sm text-muted-foreground">Nothing arrived? Check your spam folder, or ask your administrator to send a reset.</p>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Reset your password" description="Enter your email and we’ll send you a link to choose a new password." footer={back}>
      <form onSubmit={submit} className="grid gap-4" noValidate>
        <FormError message={send.isError ? errorMessage(send.error) : null} />
        <Field id="email" label="Email">
          <Input id="email" type="email" autoComplete="username" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Button type="submit" size="lg" disabled={send.isPending || !email.includes('@')}>
          {send.isPending ? 'Sending…' : 'Send reset link'}
        </Button>
      </form>
    </AuthShell>
  );
}
